import { Component, OnInit } from '@angular/core';
import { ExtraExpenseService } from 'src/app/services/extra-expense.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ExtraExpenseJob } from 'src/app/models/extra-expense-job';
import { ExtraExpense } from 'src/app/models/extra-expense';

@Component({
  selector: 'app-expenses-job',
  templateUrl: './expenses-job.component.html',
  styleUrls: ['./expenses-job.component.css']
})
export class ExpensesJobComponent implements OnInit {
  public jobs:ExtraExpenseJob[] = [];
  public expense:ExtraExpense = null;
  public loading = false;
  public job:ExtraExpenseJob = new ExtraExpenseJob();
  public expand:boolean = false;

  public actEdit:boolean = true;
  public actAdd:boolean = true;
  public actDelete:boolean = true;

  constructor(private extraExpServ:ExtraExpenseService, private modalService: NgbModal, private utl:UtilitiesService, private authService:AuthService, private toastr: ToastrManager) { }

  ngOnInit() {
    this.getJobs();
    this.actEdit = this.authService.can("update-extra-expense-job");
    this.actDelete = this.authService.can("destroy-extra-expense-job");
    this.actAdd = this.authService.can("store-extra-expense-job");
  }

  getJobs() {
    this.loading = true;
    this.extraExpServ.getExtraExpensesJob().then(jobs => {
      this.jobs = jobs;
      this.loading = false;
    });
  }

  select(modal?, job?:ExtraExpenseJob) {
    if(job) {
      this.job = job;
      this.expense = this.job.extraExpense;
    } else {
      this.job = new ExtraExpenseJob();
      this.expense = null;
    }

    if(modal) {
      this.modalService.open(modal, { size: 'lg' });
    }
  }

  updateJob() {
      this.loading = true;
      this.extraExpServ.putExtraExpenseJob(this.job)
        .then(res => {
          this.getJobs();
          this.modalService.dismissAll();
          this.toastr.successToastr('Actualizado correctamente', 'Bien');
        })
        .catch(e => {
          this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
          this.loading = false;
        });
  }

  storeJob() {
      this.loading = true;
      this.extraExpServ.postExtraExpenseJob(this.job)
        .then(res => {
          this.getJobs();
          this.modalService.dismissAll();
          this.toastr.successToastr('Creado correctamente', 'Bien');
        })
        .catch(e => {
          this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
          this.loading = false;
        });
  }

  deleteJob() {
    this.loading = true;
    this.extraExpServ.deleteExtraExpenseJob(this.job)
      .then(resp => {
        this.getJobs();
        this.modalService.dismissAll();
        this.toastr.successToastr('Eliminado correctamente', 'Bien');
      })
      .catch(e => {
        this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
        this.loading = false;
      });
  }

  getExtraExpense() {
    this.loading = true;
    this.extraExpServ.getExtraExpense(this.job.extra_expense_id)
      .then(expense => {
        this.expense = expense;
        this.loading = false;
      }).catch(e => {
        this.toastr.errorToastr('Gasto no encontrado!!');
        this.loading = false;
      });
  }

}
